import { Router } from '@angular/router';

import { scrubUrl } from '../modules/appinsights/telemetry-scrubber';

/**
 * Drops the fragment and redacts sensitive query params (via the shared
 * {@link scrubUrl}) while keeping the rest of the query string, so a `page`
 * dimension retains useful filter/sort/paging state without leaking tokens or
 * PII. Returns an empty string for empty input.
 * @param path
 */
export function sanitizePath(path: string | undefined): string {
  if (!path) {
    return '';
  }
  return scrubUrl(path.split('#')[0]);
}

/**
 * Builds the stable route template (e.g. `/orders/:id`) for the active route by
 * walking the matched route configs from the router state root to the leaf.
 * Low cardinality, so it groups cleanly in dashboards. Returns an empty string
 * when no Router is available.
 * @param router
 */
export function buildRouteName(router: Router | null): string {
  if (!router) {
    return '';
  }
  let route = router.routerState.snapshot.root;
  const parts: string[] = [];
  while (route.firstChild) {
    route = route.firstChild;
    if (route.routeConfig?.path) {
      parts.push(route.routeConfig.path);
    }
  }
  return `/${parts.join('/')}`;
}

/**
 * Reads the current browser path with query string, ready for {@link sanitizePath}.
 * Safe when `window`/`location` are unavailable.
 */
export function currentLocationPath(): string {
  return `${window.location?.pathname ?? ''}${window.location?.search ?? ''}`;
}
